import axios from "axios";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const DEFAULT_TIMEOUT = process.env.REACT_APP_SERVER_TIMEOUT || 10000;

const DEFAULT_CONFIGS = {
    timeout: DEFAULT_TIMEOUT,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
};

/**
 * @typedef {"GET" | "POST" | "PUT" | "PATCH" | "DELETE"} Method
 */

class HttpService {
    constructor() {
        this.#initializeInterceptors();
    }

    #initializeInterceptors() {
        axios.interceptors.request.use(
            (config) => {
                if (config.headers["Enable-Auth-Token"]) {
                    const token = localStorage.getItem("token");
                    if (token) {
                        config.headers["Authorization"] = `Bearer ${token}`;
                    } else {
                        delete config.headers["Authorization"];
                    }

                    delete config.headers["Enable-Auth-Token"];
                }

                config.headers["Request-Language"] = sessionStorage.getItem("Request-Language");

                return config;
            },
            (error) => Promise.reject(error)
        );
    }

    /**
     * @param {Method} method
     * @param {string} url
     * @param {object} data
     * @param {object} configs
     * @returns {Promise<import("axios").AxiosResponse<any>>}
     */
    async fetch(method, url, data, configs) {
        switch (method) {
            case "GET":
            case "DELETE":
                return axios[method.toLowerCase()](url, {
                    ...configs,
                    params: data,
                });
            case "POST":
            case "PUT":
            case "PATCH":
                return axios[method.toLowerCase()](url, data, configs);
            default:
                throw new Error("Invalid method");
        }
    }

    /**
     *
     * @param {Method} method
     * @param {string} service
     * @param {string} operation
     * @param {object} data
     * @param {object} configs
     * @returns {Promise<import("axios").AxiosResponse<any>>}
     */
    async controlServer(method, service, operation, data = {}, configs = DEFAULT_CONFIGS) {
        return this.fetch(method, `${SERVER_URL}/api/${service}/${operation}`, data, {
            ...configs,
            headers: {
                ...configs.headers,
            },
        });
    }

    /**
     *
     * @param {Method} method
     * @param {string} service
     * @param {string} operation
     * @param {object} data
     * @param {object} configs
     * @returns {Promise<import("axios").AxiosResponse<any>>}
     */
    async controlServerWithToken(method, service, operation, data = {}, configs = DEFAULT_CONFIGS) {
        return this.controlServer(method, service, operation, data, {
            ...configs,
            headers: {
                ...configs.headers,
                ["Enable-Auth-Token"]: true,
            },
        });
    }
}

// eslint-disable-next-line
export default new HttpService();
